<script setup lang="ts">
import Icon from "@/core/components/icon/Icon.vue";
import {useRouter} from "vue-router";

defineProps<{ title?: string; size?: number }>();
const router = useRouter();

/**
 * Navigate back to the previous page.
 * Do nothing if the navigation would lead to the app loading page.
 */
const goBack = () => {
    if (['/login', '/app-loading'].includes(window.history.state.back)) {
        return;
    }

    router.go(-1);
};

</script>

<template>
  <div class="flex flex-row items-center p-3">
    <button class="flex items-center" @click="goBack">
      <div class="flex items-center bg-primary rounded-full p-1 justify-center mr-3">
        <Icon name="mdi-arrow-left" color="white" :size="size || 18" />
      </div>
      <div v-if="title" class="text-primary text-base font-semibold">
        {{ title }}
      </div>
    </button>
  </div>
</template>
